export type PhonePrivacyRecommendationAction = 'apply' | 'dismiss';

/** 只有采用隐私建议才恢复此前暂缓的字段保存；忽略或关闭提示必须继续停留在浮层。 */
export function shouldResumePhonePrivacySave(
  savePending: boolean,
  action: PhonePrivacyRecommendationAction
): boolean {
  return savePending && action === 'apply';
}
